import { Tag, Typography, theme } from 'antd';
import { FC } from 'react';
import { CheckCircleFill, ExclamationCircleFill, QuestionCircleFill, XCircleFill } from 'react-bootstrap-icons';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  verdict: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['verdict'] | null;
}

export const VerdictTag: FC<Props> = ({ verdict }) => {
  const { token: { colorSuccess, colorTextSecondary, colorError } } = theme.useToken();

  if (verdict) {
    if (verdict === 'NEUTRAL') {
      return <Tag color="default" style={{ fontSize: 14 }}>
        <ExclamationCircleFill color={ colorTextSecondary }/>&nbsp;Нейтральний
      </Tag>;
    }
    if (verdict === 'PASS') {
      return <Tag color="default" style={{ fontSize: 14 }}>
        <CheckCircleFill color={ colorSuccess }/>&nbsp;URL є доступним для Google
      </Tag>;
    }
    if (verdict === 'VERDICT_UNSPECIFIED') {
      return <Tag color="default" style={{ fontSize: 14 }}>
        <QuestionCircleFill color={ colorTextSecondary }/>&nbsp;Не визначений
      </Tag>;
    }
    if (verdict === 'FAIL') {
      return <Tag color="default" style={{ fontSize: 14 }}>
        <XCircleFill color={ colorError }/>&nbsp;Невдача
      </Tag>;
    }
  } else {
    return <Typography.Text type="secondary" style={{ fontSize: 14 }}>(недоступно)</Typography.Text>;
  }
};
